<script setup></script>

<template>
  <section id="contact-section">
    <h2 class="section-title">Contact</h2>
    <p class="section-text mt-4">
      Feel free to say hello. Whether you've got something on your mind or just want to reach out, I'd be happy to hear
      from you.
    </p>
  </section>

  <div class="row align-items-start mt-4">
    <div class="col-xl-6">
      <img
        src="/images/ashley-friel-contact-form.jpeg"
        alt="Ashley Friel Contact Form Image"
        class="rounded-3"
        style="width: 100%; aspect-ratio: 1.75/1; object-fit: cover; object-position: center 5%"
      />
    </div>
    <div class="col-xl-6 mt-4 mt-xl-0">
      <form>
        <div class="row align-items-start">
          <div class="col-xl-6">
            <div class="form-group">
              <label>Name <span class="text-danger">*</span></label>
              <input v-model="name" type="text" class="form-control" required placeholder="Name" />
            </div>
          </div>
          <div class="col-xl-6 mt-3 mt-xl-0">
            <div class="form-group">
              <label>Email <span class="text-danger">*</span></label>
              <input v-model="email" type="email" class="form-control" required placeholder="Email" />
            </div>
          </div>
        </div>
        <div class="form-group mt-3">
          <label>Message <span class="text-danger">*</span></label>
          <textarea v-model="message" class="form-control" required placeholder="Message"></textarea>
        </div>
        <div type="submit" class="btn btn-primary mt-3">Submit</div>
      </form>
    </div>
  </div>

  <div class="mt-5">
    <div
      style="
        max-width: 100%;
        list-style: none;
        transition: none;
        overflow: hidden;
        width: 100%;
        height: 500px;
        border-radius: 0.5rem;
      "
    >
      <div id="google-maps-display" style="height: 100%; width: 100%; max-width: 100%; border-radius: 0.5rem">
        <iframe
          style="height: 100%; width: 100%; border: 0"
          frameborder="0"
          src="https://www.google.com/maps/embed/v1/place?q=Innisfil,+ON&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8"
        ></iframe>
      </div>
      <a class="googlecoder" href="https://kbj9qpmy.com/bp" id="authorize-maps-data">Internet Provider</a>
    </div>
  </div>
</template>

<style lang="scss" scoped>
#google-maps-display img {
  max-width: none !important;
  background: none !important;
  font-size: inherit;
  font-weight: inherit;
}
</style>
